import { render, staticRenderFns } from "./deleteStudentRoute.vue?vue&type=template&id=526fbf51&"
import script from "./deleteStudentRoute.vue?vue&type=script&lang=js&"
export * from "./deleteStudentRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports